module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idThumPan",
    staticStyle: {
      "float": "left",
      "position": "relative",
      "width": "253px",
      "height": "253px",
      "border": "0px solid red"
    }
  }, [_c('div', {
    ref: "idThum",
    staticStyle: {
      "float": "left",
      "border": "0px solid red"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3070c3ef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/TPThum.vue
// module id = 763
// module chunks = 1